import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MobilePrinter.css';

import LoadingIndicator from '../../../layout/LoadingIndicator/LoadingIndicator';

interface PrinterListSelectorProps {
  translationRoot: string;
  printerList: string[];
  listError: string | null;
  onPrinterSelect: (printer: string) => void;
  selectedPrinter: string;
  isMobilePrinterListLoading: boolean;
}

const PrinterListSelector: React.FC<PrinterListSelectorProps> = ({
  translationRoot,
  printerList,
  listError,
  onPrinterSelect,
  selectedPrinter,
  isMobilePrinterListLoading,
}) => {
  const { t } = useTranslation();

  const renderContent = () => {
    if (isMobilePrinterListLoading) {
      return <LoadingIndicator />;
    }
    if (listError) {
      return <div className={styles.printerListError}>{t(`${translationRoot}.MOBILE_PRINTER_LIST_ERROR`)}</div>;
    }

    if (printerList.length > 0) {
      return (
        <div className={styles.printerListWrapper} role="radiogroup" aria-labelledby="printer-list-label">
          {printerList.map(printer => (
            <label key={printer} className={styles.printerItem} htmlFor={`printer-${printer}`}>
              <input
                type="radio"
                id={`printer-${printer}`}
                name="printerSelection"
                value={printer}
                checked={selectedPrinter === printer}
                onChange={() => onPrinterSelect(printer)}
                className={styles.printerRadio}
                aria-label={`${t(`${translationRoot}.PRINTER`)} ${printer}`}
                aria-checked={selectedPrinter === printer}
              />
              <div className={styles.printerNumber} aria-hidden="true">
                {t(`${translationRoot}.PRINTER`)} {printer}
              </div>
            </label>
          ))}
        </div>
      );
    }

    return null;
  };

  return (
    <div className={styles.printerListContainer}>
      <div id="printer-list-label" className={styles.printerListLabel}>
        {t(`${translationRoot}.SELECT_MOBILE_PRINTER_FROM_LIST`)}
      </div>

      {renderContent()}
    </div>
  );
};

export default React.memo(PrinterListSelector);
